import React, { useState } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Philosophy } from "../components/Philosophy";
import { Setting } from "../components/Setting";
import { Rooms } from "../components/Rooms";
import { Inclusions } from "../components/Inclusions";
import { Founder } from "../components/Founder";
import { CTA } from "../components/CTA";
import { Footer } from "../components/Footer";
import { WaterWaves } from "../components/WaterShimmer";
import { translations } from "../translations";

export default function LandingPage() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];

  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#e7e7e5] text-stone-900 antialiased"
    >
      <Nav lang={lang} setLang={setLang} t={t} />
      <Hero t={t} />
      <Philosophy t={t} />
      <div className="relative bg-[#e7e7e5] h-24 md:h-32">
        <WaterWaves className="inset-0" />
      </div>
      <Setting t={t} />
      <Rooms t={t} />
      <Inclusions t={t} />
      <Founder t={t} />
      <CTA t={t} />
      <Footer t={t} />
    </div>
  );
}
